export default __webpack_public_path__ + "static/media/Top Large 2V7.c93b3cbb.mp4";